import { objectSchema } from "vue-utils"
import { extend, type Id, type Nullable } from "./GenericEntity"
import { PagedResult, type PagedRequest } from "./Paged"
import type { SortDirection } from "./Sorting"
import { TFSEntryMetadata } from "./TFSEntry"
import type { TFSStatus } from "./TFSStatus"

export interface TFSSearchResult extends PagedResult {
	globalTotal: number
	entries: TFSEntryMetadata[]
}
export const TFSSearchResult = objectSchema<TFSSearchResult>({
	...extend(PagedResult),
	globalTotal: Number,
	entries: TFSEntryMetadata.array(),
})

export interface TFSSearchRequest extends PagedRequest {
	filter: TFSSearchFilter
	sortBy: Nullable<TFSSearchSorting>
	sortDirection: Nullable<SortDirection>
}

export interface TFSSearchFilter {
	companyIds: Id[]
	consentIssued: Nullable<boolean>
	statuses: TFSStatus[]
	tfsNumber: Nullable<string>
	wkNumber: Nullable<string>
}

export enum TFSSearchSorting {
	TFSNumber = "TFSNumber",
	WKNumber = "WKNumber",
	CompanyName = "CompanyName",
	ValidFrom = "ValidFrom",
	ValidTo = "ValidTo",
	ConsentIssued = "ConsentIssued",
	MaximumShipments = "MaximumShipments",
	MaximumActiveShipments = "MaximumActiveShipments",
	CancelledShipments = "CancelledShipments",
	CompletedShipments = "CompletedShipments",
	ActiveShipments = "ActiveShipments",
	TotalShipments = "TotalShipments",
	Status = "Status",
}
